var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSlash24(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2004 3.54193C16.4534 3.65261 16.5688 3.94742 16.4581 4.20041L9.45808 20.2004C9.3474 20.4534 9.05258 20.5688 8.79959 20.4581C8.5466 20.3474 8.43124 20.0526 8.54193 19.7996L15.5419 3.79959C15.6526 3.5466 15.9474 3.43124 16.2004 3.54193Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSlash24);
export default __webpack_public_path__ + "static/media/icon-slash-24.a17d0b27.svg";
export { ForwardRef as ReactComponent };